import React from "react";
import MainLayout from "../../../components/Layouts";
import ShopReturnOrdersList from "../../../components/Orders/ReturnOrderList";

const ShopReturnOrderPage = () => {
  return (
    <MainLayout>
      <ShopReturnOrdersList />
    </MainLayout>
  );
};

export default ShopReturnOrderPage;
